import { render, staticRenderFns } from "./ActiveCalls.vue?vue&type=template&id=7ab91649&scoped=true&"
import script from "./ActiveCalls.vue?vue&type=script&lang=js&"
export * from "./ActiveCalls.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCalls.vue?vue&type=style&index=0&id=7ab91649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab91649",
  null
  
)

export default component.exports